import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { AccountRegistrationSliderEvent } from '../../../interfaces/account-registration-slider-event.interface';

@Component({
  selector: 'acl-account-confirm',
  standalone: false,
  templateUrl: './account-confirm.component.html',
  styleUrl: './account-confirm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountConfirmComponent {
  @Output() readonly slideTo =
    new EventEmitter<AccountRegistrationSliderEvent>();

  // if user already have an account
  userActionYes(): void {
    this.slideTo.emit({ slideNo: 1, user: '' });
  }

  // if user already doesn't have an account
  userActionNo(): void {
    this.slideTo.emit({ slideNo: 3, user: '' });
  }
}
